<template>
  <div class="hidden"></div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores'
import { verifyToken } from '@/api'

export default {
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()

    const HEARTBEAT_INTERVAL = 3000
    const MAX_SUCCESSFUL_COUNT = 1

    let intervalId = null
    let successCount = 0

    const sendHeartbeat = async () => {
      if (!authStore.sessionUuid) return

      try {
        await verifyToken()
        successCount++

        if (successCount >= MAX_SUCCESSFUL_COUNT && intervalId) {
          clearInterval(intervalId)
          intervalId = null
        }
      } catch (error) {
        authStore.logout()
        router.push('/')
      }
    }

    onMounted(() => {
      intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL)
    })

    onUnmounted(() => {
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    })

    return {}
  }
}
</script>
